import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined';
import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import SettingsOutlinedIcon from '@mui/icons-material/SettingsOutlined';

import { ROUTES } from '@constants/routes';

const navigationConfig = {
  public: [],
  /** Tradock-style grouped sidebar sections (Bloodhound modules). */
  sections: [
    {
      id: 'main',
      label: null,
      items: [
        {
          id: 'dashboard',
          label: 'Dashboard',
          path: ROUTES.DASHBOARD,
          icon: DashboardOutlinedIcon,
        },
      ],
    },
    {
      id: 'people',
      label: 'People',
      items: [{ id: 'users', label: 'Users', path: ROUTES.USERS, icon: GroupOutlinedIcon }],
    },
    {
      id: 'system',
      label: 'System',
      items: [
        { id: 'settings', label: 'Settings', path: ROUTES.SETTINGS, icon: SettingsOutlinedIcon },
        { id: 'help', label: 'Help', path: ROUTES.HELP, icon: HelpOutlineOutlinedIcon },
      ],
    },
  ],
};

export default navigationConfig;
